export default __webpack_public_path__ + "static/media/Michelle.13820fc7.jpg";